import { Flex, Text, useTheme } from '@chakra-ui/react';
import { ReactComponent as SadEmoji } from '../../../logos/sadEmoji.svg';

const NoResultsPanel = () => {
  const theme = useTheme();
  return (
    <Flex
      direction='column'
      align='center'
      justify='center'
      bg='white'
      width='100%'
      height='80%'
    >
      <SadEmoji width='80px' height='80px' mb={1} />
      <Text fontSize='2xl' color={theme.colors?.blueOne} fontWeight='bold'>
        Oops!
      </Text>
      <Text fontSize='lg' color={theme.colors?.blueOne} mb={8}>
        It looks like we couldn’t find any matches for your current search.
      </Text>
      <Text fontSize='md' color={theme.colors?.smoky} textAlign='center' px={6}>
        Try adjusting your filters for a wider search, or feel free to ask me
        directly.
      </Text>
      <Text fontSize='md' color={theme.colors?.smoky} textAlign='center' px={6}>
        I’m here to help you find what you need!
      </Text>
    </Flex>
  );
};

export default NoResultsPanel;
